module.exports = __webpack_public_path__ + "img/profit.c2262def.svg";